
// Compile our scss
// This 'includes' the SCSS index file which webpack then reads and 
// compiles into the necessary css files
require('../scss/index.scss');

import "./app";

require('./components/popups.js');
require('./components/cutsafely-smoothscroll.js');
require('./components/HomepageVideo.js');
require('./components/button-arrow-resizing.js');
require('./components/responsive-table-display.js');
require('./components/iframe-resize.js');


function PageSetup() {
	memberNav();
	sidebarNavToggle();
	submissionFunctionality();

	if($('.notice_toggle').length){
		toggleNotice();
	}

	deleteMessageConfirm();

	if($('.EventItemPage').length){
		toggleForm();
	}


	//if url path includes /finished we have completed a userform, we want to scroll to the element
	if(window.location.pathname.includes('/finished')){
		if($('.userform__complete').length){
			$('.userform__complete').get(0).scrollIntoView();
		}
	}
	
}


function toggleForm() {
	var formWrapper = $('.event_registration_wrapper');
	$('.event_registration_wrapper .toggle_form').on('click', function(){
		formWrapper.find('.event_form_wrapper').slideToggle();
	});
}

function deleteMessageConfirm() {
	$('#Form_deleteMessageForm').on('submit', function(){
		if(confirm('Are you sure you want to delete this message?')){
			return;
		} else {
			return false;
		}
	});

	$('#Form_deleteCommentForm').on('submit', function(){
		if(confirm('Are you sure you want to delete this notice?')){
			return;
		} else {
			return false;
		}
	});
}


function toggleNotice() {
	var notice = $('.notice_toggle');

	notice.on('click', function(){
		var parent = $(this).closest('.intro_notice_tile');
		var noticeBody = parent.find('.intro_notice_body');
		$(this).toggleClass('active');
		noticeBody.slideToggle();
	});
}


function submissionFunctionality() {
	var parent,
		formWrapper,
		createMessageButton,
		messageBody,
		submissionButtonWrapper,
		submissionArea

	function resetVars(){
		formWrapper != null ? formWrapper.addClass('hide') : null;
		submissionButtonWrapper != null ? submissionButtonWrapper.removeClass('hide') : null;
		messageBody != null ? messageBody.removeClass('hide') : null;
	}


	function handleOnPress(button, $this) {
		resetVars();
		submissionButtonWrapper = $this.closest('.submission_button_wrapper');
		submissionButtonWrapper.addClass('hide');
		submissionArea = button === 'create_submission' ? $this.closest('.create_submission_wrapper') : $this.closest('.submission_area');
		formWrapper = submissionArea.find('.submission_form_wrapper');
		formWrapper.removeClass('hide');

		if(button === 'edit_submission'){
			parent = $this.closest('.tile');
			messageBody = parent.find('> .message_body');
			messageBody.addClass('hide');
		}
	}


	$('.create_submission').on('click', function(e){
		e.preventDefault();
		handleOnPress('create_submission', $(this));
	});

	$('.edit_submission').on('click', function(e){
		e.preventDefault();
		handleOnPress('edit_submission', $(this));
	});

	$('.add_comment_submission').on('click', function(e){
		e.preventDefault();
		handleOnPress('add_comment_submission', $(this));
	});

	$('.cancel_form').on('click', function(e){
		e.preventDefault();
		formWrapper.addClass('hide');
		submissionButtonWrapper.removeClass('hide');
		if(messageBody){
			messageBody.removeClass('hide');
		}
	});
}


// Ajax functionality for the Notice page
function DoAjaxCreateMessage(url, destination){

	// Get the url params
	
	// baseUrl = baseUrl.slice(0,-1);
	// var path = window.location.pathname;

	// Set the url.
	// if(secondaryFilter){
	// 	var url = baseUrl + path + '/' + filter + '/' + secondaryFilter;
	// 	window.location.hash = filter + '/' + secondaryFilter;
	// } else{
	// 	var url = baseUrl + path + '/' + filter;
	// 	window.location.hash = filter;
	// }


	$.ajax({
		url: url,
		method: 'POST',
		data: {},
		success: function(response){
			// displayListView(response, destination, filter);
		},
		fail: function(response){
			// destination.html('<div class=""><h1>Oops</h1><p>The filter being used is not valid.</p></div>');
		}
	});
}

function sidebarNavToggle(){
	$('.menu_arrow').click(function(e){
		e.preventDefault();
		$(this).toggleClass('sub_nav_active');
		var parent = $(this).parent('.has_children');

		if(parent){
			var subNav = parent.find('> .sub_menu');
			subNav.slideToggle();
		}
		return;
	});
}

function memberNav(){
	$('.member_nav_toggle').click( function(){
		$(this).toggleClass('open');
		$('.member_hamburglar').toggleClass('open');
		$('.member_sidebar_nav').toggleClass('active');
	});
}


/**
 * On page load
 **/
$(document).ready( function(){
	PageSetup();
});

